export const voiceLogsConstants = {
    GET_VOICE_LOG_DATA_REQUEST: 'GET_VOICE_LOG_DATA_REQUEST',
    GET_VOICE_LOG_DATA_SUCCESS: 'GET_VOICE_LOG_DATA_SUCCESS',
    GET_VOICE_LOG_DATA_FAILURE: 'GET_VOICE_LOG_DATA_FAILURE',
}